/* 🤖 this file was generated by svg-to-ts */
export const iconZk: {
  name: 'zk';
  data: string;
} = {
  name: 'zk',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#000" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="m4.08 16 6.81-6.81v3.4h6.81l-6.81 5.11v5.11zm23.84 0-6.81 6.81v-3.4H14.3l6.81-5.11V9.19z"/></svg>`,
};
